import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	assetList: {
		requesting: false,
		items: [],
		pagination: {
			current_page: 1,
			per_page: 10,
			total: 0,
		},
		error: null,
		success: false,
		filters: {},
	},
	assetDetails: {
		requesting: false,
		data: null,
		error: null,
		success: false,
	},
};

export const assetSlice = createSlice({
	name: "asset",
	initialState,
	reducers: {
		getAssetList: (state, action) => {
			state.assetList.requesting = true;
			state.assetList.error = null;
			state.assetList.items = [];
			state.assetList.success = false;
			state.assetList.filters = action.payload;
		},
		getAssetListSuccess: (state, action) => {
			const { data, current_page, per_page, total } = action.payload;

			state.assetList.requesting = false;
			state.assetList.items = data;
			state.assetList.success = true;
			state.assetList.pagination.current_page = current_page;
			state.assetList.pagination.per_page = per_page;
			state.assetList.pagination.total = total;
		},
		getAssetListFail: (state, action) => {
			state.assetList.requesting = false;
			state.assetList.error = action.payload;
		},

		getAssetDetails: (state) => {
			state.assetDetails.requesting = true;
			state.assetDetails.error = null;
			state.assetDetails.data = null;
			state.assetDetails.success = false;
		},
		getAssetDetailsSuccess: (state, action) => {
			state.assetDetails.requesting = false;
			state.assetDetails.data = action.payload;
			state.assetDetails.success = true;
		},
		getAssetDetailsFail: (state, action) => {
			state.assetDetails.requesting = false;
			state.assetDetails.error = action.payload;
		},

		doAssetCreate: (state) => {
			state.assetDetails.requesting = true;
			state.assetDetails.error = null;
			state.assetDetails.data = null;
			state.assetDetails.success = false;
		},
		doAssetCreateSuccess: (state, action) => {
			state.assetDetails.requesting = false;
			state.assetDetails.data = action.payload;
			state.assetDetails.success = true;
		},
		doAssetCreateFail: (state, action) => {
			state.assetDetails.requesting = false;
			state.assetDetails.error = action.payload;
			state.assetDetails.success = false;
		},

		doAssetUpdate: (state) => {
			state.assetDetails.requesting = true;
			state.assetDetails.error = null;
			state.assetDetails.data = null;
			state.assetDetails.success = false;
		},
		doAssetUpdateSuccess: (state, action) => {
			state.assetDetails.requesting = false;
			state.assetDetails.data = action.payload;
			state.assetDetails.success = true;
		},
		doAssetUpdateFail: (state, action) => {
			state.assetDetails.requesting = false;
			state.assetDetails.error = action.payload;
			state.assetDetails.success = false;
		},

		doAssetDelete: (state) => {
			state.assetDetails.requesting = true;
			state.assetDetails.error = null;
			state.assetDetails.data = null;
			state.assetDetails.success = false;
		},

		doAssetReset: (state) => {
			state.assetDetails.data = null;
		},
	},
});

export const {
	getAssetList, getAssetListSuccess,
	getAssetListFail, getAssetDetails,
	getAssetDetailsSuccess, getAssetDetailsFail,
	doAssetCreate, doAssetCreateSuccess,
	doAssetCreateFail, doAssetUpdate,
	doAssetUpdateSuccess, doAssetUpdateFail,
	doAssetDelete, doAssetReset,
} = assetSlice.actions;

export default assetSlice.reducer;